import React from 'react';
import { getTimezoneContext } from '@/utils';

import './EventTimezoneNote.scss';

const EventTimezoneNote = ({ event, referenceDate, className }) => {
	const { eventAbbreviation, localAbbreviation, matchesLocalTime } = getTimezoneContext(
		event,
		referenceDate
	);

	return (
		<p className={`EventTimezoneNote ${className || ''}`}>
			All times in event time ({eventAbbreviation})
			{!matchesLocalTime && `. Your computer local time is ${localAbbreviation}.`}
		</p>
	);
};

export default EventTimezoneNote;
